export class UsuarioFilter {
  nombre?: string;
  apellido?: string;
  nomPublico?: string;
  correoElectronico?: string;
}
